import { HECO_CUSTOMER_APPLICATION_FORM_ERROR, HECO_CUSTOMER_APPLICATION_FORM_UPDATE } from '../Actions/CustomerApplicationForm.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    name: '',
    email: '',
    organizationName: '',
    organizationNumber: '',
    organizationStreet: '',
    organizationCity: '',
    organizationZip: '',
    errors: {},
    submitted: false
};

export const customerApplication = (state = defaultState, action) => {
    switch (action.type) {
        case HECO_CUSTOMER_APPLICATION_FORM_UPDATE:
            return {
                ...state,
                ...action.payload.customerApplication,
                errors: {},
            };
        case HECO_CUSTOMER_APPLICATION_FORM_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
